var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0115 4.58887C19.5191 4.58887 14.9241 3.41039 13.2862 1.227C13.0683 0.961691 12.6767 0.923441 12.4113 1.14136C12.38 1.16702 12.3513 1.19572 12.3257 1.22705C10.6876 3.4102 6.09265 4.58887 2.60047 4.58887C2.26878 4.58887 2 4.85761 2 5.1892V12.9934C2 19.5947 7.73247 23.5743 12.6412 24.9765C12.7488 25.0078 12.8631 25.0078 12.9707 24.9765C17.8794 23.5743 23.6119 19.5947 23.6119 12.9934V5.1892C23.6119 4.85761 23.3431 4.58882 23.0115 4.58882V4.58887ZM22.4111 12.9934C22.4111 18.8537 17.2755 22.4461 12.806 23.7748C8.33632 22.4462 3.20056 18.8537 3.20056 12.9934V5.77903C6.67066 5.6617 10.774 4.54307 12.8059 2.49942C14.8381 4.54307 18.9412 5.6617 22.4113 5.77888V12.9934L22.4111 12.9934Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4049 10.5922V11.7928H9.80448C9.47288 11.7928 9.2041 12.0616 9.2041 12.3932V17.1957C9.2041 17.5273 9.47288 17.7961 9.80448 17.7961H15.8078C16.1394 17.7961 16.4082 17.5273 16.4082 17.1957V12.3932C16.4082 12.0616 16.1394 11.7928 15.8078 11.7928H15.2074V10.5922C15.2074 9.26595 14.1324 8.19092 12.8061 8.19092C11.4799 8.19092 10.4049 9.26595 10.4049 10.5922ZM15.2074 16.5955H10.4049V12.9934H15.2073L15.2074 16.5955ZM14.0068 10.5922V11.7928H11.6055V10.5922C11.6055 9.92914 12.1429 9.39157 12.8061 9.39157C13.4692 9.39157 14.0068 9.92914 14.0068 10.5922Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycIcon);
export default __webpack_public_path__ + "static/media/kyc_icon.7710b3aa1f4ca8fe0914c0b4e7563a0b.svg";
export { ForwardRef as ReactComponent };